import App from '@/models/App'

export default class SelectShipSkill extends App {
    static get entity() {
        return 'SelectShipSkills'
    }
    static all() {
        return this.query().get()
    }
    static findByCode(code) {
        if (code === 'no data') {
            return { ja: 'no data', en: 'no data' }
        }
        return this.query().where('value', code).first()
    }
    static sortSailors(sailors) {
        const shipSkills = this.all().map((s) => s.value)
        return sailors.sort((a, b) => {
            return (
                shipSkills.indexOf(a.shipSailorInfo.skill) -
                shipSkills.indexOf(b.shipSailorInfo.skill)
            )
        })
    }
    static fields() {
        return {
            id: this.attr(''),
            value: this.attr(''),
            ja: this.attr(''),
            en: this.attr(''),
        }
    }
    static apiConfig = {
        actions: {
            fetch() {
                return this.get(`/env/select/ship/skill`, {
                    params: {},
                    headers: {
                        'Accept-Language': App.acceptLanguage(),
                    },
                    dataKey: 'data',
                    baseURL: App.apiURL(),
                })
            },
        },
    }
}
